export default function (v7, v9) {
	let v12 = 1
	for (var i = 0; i < v9; i++) {
		v12 = v12 * v7
	}
	return v12
}



// WEBPACK FOOTER //
// ./src/assets/formulas/exponent.js